
/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const selectLoader = (state: { loader: any; }) => state.loader.displayLoader;
export const selectShowHideUserLoader = (state: { loader: any; }) => state.loader.displayShowHideUserLoader;
export const selectShowHideRoleAssignmentLoader = (state: { loader: any; }) => state.loader.displayShowHideRoleAssignmentLoader;
export const selectShowHideBuiltinPoliciesLoader = (state: { loader: any; }) => state.loader.displayShowHideBuiltinPoliciesLoader;